<tan-loader [loading]="!hasTransport" [loadingText]="'<p>Getting Transport pricing</p>'">
</tan-loader>

<div class="row mt-3" *ngIf="hasTransport">
  <div class="col-sm-12">
    <tan-table [data]="transportCharges" [loading]="(transportChargesLoading$ | async)" [canSearch]="false"
      [filterConfigItems]="filterDropdownOptions" [error]="(transportChargesError$ | async)" [iconClass]="iconClass"
      [totalPages]="pageCount" [itemCount]="itemCount" [currentPage]="currentPage" (onPageClick)="paginate($event)"
      (onClickViewItem)="viewItem($event)" (onClickRetry)="retry()" [canBulkEdit]="false" [columnConfig]="columnConfig"
      [page]="'transportCharges'" (searchTerm)="search($event)" (onFilter)="filter($event)"
      (onClickSort)="sort($event)">
    </tan-table>
  </div>
</div>